import { createApp } from 'vue';
import App from '@/App.vue';
import moment from 'dayjs';
import router from './router';
import store from './store';
import tooltip from '@/utils/tooltip';
// import { useI18n } from 'vue-i18n'
import i18n, { I18nT } from './plugins/i18n';
import BaseIcon from './rex-components/BaseIcon.vue';
import './assets/styles/_custom.scss';
import getLocalTime from '@/utils/time/localtime';
import VueCookies from 'vue-cookies';
import VueApexCharts from 'vue3-apexcharts';
import BuildConfig from '@/environment';
import userLoginChannel from '@/broadcast';
import clickOutside from '@/utils/clickOutside';

if (BuildConfig.VUE_APP_DISABLE_ICON === 'true') {
  const linkElement = document.querySelector(
    'link[rel="icon r-icon"]',
  ) as HTMLLinkElement;
  linkElement.href = `${process.env.BASE_URL}/favicon_ignored.ico`;
}

const app = createApp(App);

// app.component('apexchart', VueApexCharts);


// Vue.config.productionTip = false; // default to false in production in vue 3
// app.use(useI18n);
// app.config.globalProperties.$noti
app.use(VueCookies);
app.component('BaseIcon', BaseIcon);
app.directive('tooltip', tooltip);
app.directive('clickout', clickOutside);

app.config.globalProperties.$filters = {
  dateformat(dataStr, timezoneoffset, pattern = 'YYYY-MM-DD HH:mm:ss') {
    const dataDate = new Date(dataStr);
    const date = getLocalTime(timezoneoffset, dataDate);
    return moment(date).format(pattern);
  },
};

// app.config.globalProperties.$filters('dateformatCal', (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') =>
//   moment(dataStr).format(pattern)
// );

app.use(router);
app.use(store);
app.use(i18n);
app.use(VueApexCharts);
app.component('i18n-t', I18nT);
app.mount('#app');

// export {app};
